const errorMessageMap = new Map<string, string>([['InvalidCaptchaError', 'CONTACTPAGE.FORM.FAIL.CAPTCHA']]);

export const getErrorMessage = (key: string): string =>
  errorMessageMap.has(key) ? (errorMessageMap.get(key) as string) : '';
